import alias from "./alias";
import dataspace from "./dataspace";
import entryPage from "./entryPage";
import processMessages from "./process";
import seat from "./seat";
import telephony from "./telephony";

// `operator` is still one flat namespace — renaming keys is a later step. The
// slices below partition it by feature; `npm run lint:i18n` fails if two of
// them declare the same key.
export default {
	operator: {
		...alias,
		...dataspace,
		...entryPage,
		...processMessages,
		...seat,
		...telephony,
	},
};
